import React, { useContext, useEffect, useMemo } from 'react';
import _get from 'lodash/get';
import { ContractSelectedContext } from '../../../Contexts/ContractsContext';
import { UserContext } from '../../../Contexts/UserContext';
import { history } from '../../../Routes/history';
import ExemptionMain from './ExemptionMain';
import { CONTRACT_TYPES } from '../../Contracts/contract_enums';

const ContributionExemptionGDC = () => {
  const currentUser = useContext(UserContext);
  const authToken = _get(currentUser, 'token');
  const selectedContract = useContext(ContractSelectedContext);

  const isValidContract = useMemo(
    () =>
      selectedContract &&
      (selectedContract.type === CONTRACT_TYPES.Industrial ||
        selectedContract.type === CONTRACT_TYPES.Unregulated),
    [selectedContract]
  );

  useEffect(() => {
    if (!authToken) {
      history.replace('/');
      return;
    }

    if (!isValidContract) {
      history.replace('/');
      return;
    }
  }, [authToken, isValidContract]);

  if (!authToken || !isValidContract) {
    return <></>;
  }

  return (
    <>
      <ExemptionMain contractId={selectedContract.id} />
    </>
  );
};

export default ContributionExemptionGDC;
